import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { _DJB2, _makeTypedGet } from '@statsig/client-core';
var LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
export var LOCAL_STORAGE_KEY = 'STATSIG_OVERRIDES';
var LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var makeEmptyStore = function makeEmptyStore() {
  return {
    gates: {},
    configs: {},
    layers: {}
  };
};

/**
 * Custom implementation of `@statsig/js-local-overrides` package with support for local storage
 * so we can keep the existing behavior where overrides are cached locally. Also designed for
 * compatibility with the old override system (eg. no `experiments` field, `configs` is used
 * instead).
 *
 * [Reference](https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-local-overrides/src/LocalOverrideAdapter.ts)
 */
export var PersistentOverrideAdapter = /*#__PURE__*/function () {
  function PersistentOverrideAdapter() {
    _classCallCheck(this, PersistentOverrideAdapter);
    this._overrides = makeEmptyStore();
  }
  return _createClass(PersistentOverrideAdapter, [{
    key: "parseStoredOverrides",
    value: function parseStoredOverrides(localStorageKey) {
      try {
        var json = window.localStorage.getItem(LOCAL_STORAGE_KEY);
        if (!json) {
          return makeEmptyStore();
        }
        return JSON.parse(json);
      } catch (_unused) {
        return makeEmptyStore();
      }
    }
  }, {
    key: "mergeOverrides",
    value: function mergeOverrides() {
      var merged = makeEmptyStore();
      for (var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++) {
        allOverrides[_key] = arguments[_key];
      }
      for (var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++) {
        var overrides = _allOverrides[_i];
        for (var _i2 = 0, _Object$entries = Object.entries(overrides.gates); _i2 < _Object$entries.length; _i2++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
            name = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          merged.gates[name] = value;
        }
        for (var _i3 = 0, _Object$entries2 = Object.entries(overrides.configs); _i3 < _Object$entries2.length; _i3++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
            _name = _Object$entries2$_i[0],
            _value = _Object$entries2$_i[1];
          merged.configs[_name] = _value;
        }
        for (var _i4 = 0, _Object$entries3 = Object.entries(overrides.layers); _i4 < _Object$entries3.length; _i4++) {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i4], 2),
            _name2 = _Object$entries3$_i[0],
            _value2 = _Object$entries3$_i[1];
          merged.layers[_name2] = _value2;
        }
      }
      return merged;
    }
  }, {
    key: "initFromStoredOverrides",
    value: function initFromStoredOverrides() {
      this._overrides = this.mergeOverrides(this.parseStoredOverrides(LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(LOCAL_STORAGE_KEY));
    }
  }, {
    key: "saveOverrides",
    value: function saveOverrides() {
      window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this._overrides));
    }
  }, {
    key: "getOverrides",
    value: function getOverrides() {
      return Object.fromEntries(Object.entries(this._overrides).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          container = _ref2[1];
        var record = {};
        for (var _i5 = 0, _Object$entries4 = Object.entries(container); _i5 < _Object$entries4.length; _i5++) {
          var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i5], 2),
            name = _Object$entries4$_i[0],
            value = _Object$entries4$_i[1];
          if (Object.prototype.hasOwnProperty.call(container, _DJB2(name))) {
            record[name] = value;
          }
        }
        return [key, record];
      }));
    }
  }, {
    key: "setOverrides",
    value: function setOverrides(overrides) {
      var newOverrides = _objectSpread(_objectSpread({}, makeEmptyStore()), overrides);
      for (var _i6 = 0, _Object$values = Object.values(newOverrides); _i6 < _Object$values.length; _i6++) {
        var container = _Object$values[_i6];
        for (var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++) {
          var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i7], 2),
            name = _Object$entries5$_i[0],
            value = _Object$entries5$_i[1];
          var hash = _DJB2(name);
          if (!Object.prototype.hasOwnProperty.call(container, hash)) {
            container[hash] = value;
          }
        }
      }
      this._overrides = newOverrides;
      this.saveOverrides();
    }
  }, {
    key: "overrideGate",
    value: function overrideGate(name, value) {
      this._overrides.gates[name] = value;
      this._overrides.gates[_DJB2(name)] = value;
      this.saveOverrides();
    }
  }, {
    key: "removeGateOverride",
    value: function removeGateOverride(name) {
      delete this._overrides.gates[name];
      delete this._overrides.gates[_DJB2(name)];
      this.saveOverrides();
    }
  }, {
    key: "getGateOverride",
    value: function getGateOverride(current, _user) {
      var _this$_overrides$gate;
      var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._overrides.gates[_DJB2(current.name)];
      if (overridden == null) {
        return null;
      }
      return _objectSpread(_objectSpread({}, current), {}, {
        value: overridden,
        details: _objectSpread(_objectSpread({}, current.details), {}, {
          reason: LOCAL_OVERRIDE_REASON
        })
      });
    }
  }, {
    key: "overrideDynamicConfig",
    value: function overrideDynamicConfig(name, value) {
      this._overrides.configs[name] = value;
      this._overrides.configs[_DJB2(name)] = value;
      this.saveOverrides();
    }
  }, {
    key: "removeDynamicConfigOverride",
    value: function removeDynamicConfigOverride(name) {
      delete this._overrides.configs[name];
      delete this._overrides.configs[_DJB2(name)];
      this.saveOverrides();
    }
  }, {
    key: "getDynamicConfigOverride",
    value: function getDynamicConfigOverride(current, _user) {
      return this._getConfigOverride(current, this._overrides.configs);
    }
  }, {
    key: "overrideExperiment",
    value: function overrideExperiment(name, value) {
      this._overrides.configs[name] = value;
      this._overrides.configs[_DJB2(name)] = value;
      this.saveOverrides();
    }
  }, {
    key: "removeExperimentOverride",
    value: function removeExperimentOverride(name) {
      delete this._overrides.configs[name];
      delete this._overrides.configs[_DJB2(name)];
      this.saveOverrides();
    }
  }, {
    key: "getExperimentOverride",
    value: function getExperimentOverride(current, _user) {
      return this._getConfigOverride(current, this._overrides.configs);
    }
  }, {
    key: "overrideLayer",
    value: function overrideLayer(name, value) {
      this._overrides.layers[name] = value;
      this._overrides.layers[_DJB2(name)] = value;
      this.saveOverrides();
    }
  }, {
    key: "removeLayerOverride",
    value: function removeLayerOverride(name) {
      delete this._overrides.layers[name];
      delete this._overrides.layers[_DJB2(name)];
      this.saveOverrides();
    }
  }, {
    key: "removeAllOverrides",
    value: function removeAllOverrides() {
      this._overrides = makeEmptyStore();
      window.localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
  }, {
    key: "getLayerOverride",
    value: function getLayerOverride(current, _user) {
      var _this$_overrides$laye;
      var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._overrides.layers[_DJB2(current.name)];
      if (overridden == null) {
        return null;
      }
      return _objectSpread(_objectSpread({}, current), {}, {
        __value: overridden,
        get: _makeTypedGet(current.name, overridden),
        details: _objectSpread(_objectSpread({}, current.details), {}, {
          reason: LOCAL_OVERRIDE_REASON
        })
      });
    }
  }, {
    key: "_getConfigOverride",
    value: function _getConfigOverride(current, lookup) {
      var _lookup$current$name;
      var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : lookup[_DJB2(current.name)];
      if (overridden == null) {
        return null;
      }
      return _objectSpread(_objectSpread({}, current), {}, {
        value: overridden,
        get: _makeTypedGet(current.name, overridden),
        details: _objectSpread(_objectSpread({}, current.details), {}, {
          reason: LOCAL_OVERRIDE_REASON
        })
      });
    }
  }]);
}();